/**
 * Created by olga on 30.04.2026
 */

Placements.ENTRIES["levelUp"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 1000,
    action: function () {
        cleverapps.gameLevel.checkLevelUp();
    }
};